import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { TONE } from '../../data/constants'
import styles from './EmptyState.module.scss'

const ICON_BY_TONE = {
  [TONE.OK]: 'fa-circle-check',
  [TONE.INFO]: 'fa-circle-info',
  [TONE.NEUTRAL]: 'fa-circle-info',
}

export default function EmptyState({ messageId, titleId = undefined, tone = TONE.NEUTRAL, values = undefined }) {
  return (
    <div className={`${styles.empty} ${styles[tone] ?? ''} d-flex gap-2 align-items-start`}>
      <i className={`fa-regular ${ICON_BY_TONE[tone] ?? ICON_BY_TONE[TONE.NEUTRAL]}`} aria-hidden="true" />
      <div>
        {titleId && (
          <div className={styles.title}>
            <FormattedMessage id={titleId} />
          </div>
        )}
        <FormattedMessage id={messageId} values={values} />
      </div>
    </div>
  )
}

EmptyState.propTypes = {
  messageId: PropTypes.string.isRequired,
  titleId: PropTypes.string,
  tone: PropTypes.oneOf([TONE.OK, TONE.INFO, TONE.NEUTRAL]),
  values: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
}
